import { useContext } from 'react'
import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'
import { FeathersContext } from '../services/feathers'

const useGetApplications = () => {
  const feathers = useContext(FeathersContext)
  const { candidateIds } = useSelector((state) => state.talent)
  const ids = candidateIds?.map((el) => el.candidateId)

  // find this agregation in hooks/aggregation/get-all-talent-applications.js on server project
  const { refetch: refetchApplications, data } = useQuery({
    queryKey: ['candidateIds'],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const allMyApplications = await feathers.service('lambda-talent').find({
        query: {
          candidateIds: ids,
        },
      })

      return allMyApplications
    },
  })
  return { refetchApplications, data }
}

export default useGetApplications
